module.exports = __webpack_public_path__ + "static/media/heatingPentair.94df4af4.jpg";